import { useLocation } from "react-router-dom";
import '../styles/App.css';
import Map from '../components/Map';

function Home() {
  const location = useLocation();
  const newPin = location.state || {};
  console.log(`NEW PIN: ${newPin}`)
  return (
    <div>

      <div className="text-gray-200 text-center">
        <div className="p-10 text-5xl font-bold text-blue-600">Welcome to FishFind!</div>
        <div className="text-xl">Browse the map where people have caught a fish!</div>
      </div>

      <br></br>
      <Map flyTo={newPin} />
    </div>
  );
}

export default Home;
